function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
import { Well, NotificationActionBuilder } from '../index';
import { Button, Skeleton } from 'antd';
import { EditOutlined, WarningOutlined } from '@ant-design/icons';
import { getDomainDefaultActionLabels, getNotificationActionOrDefault, getClassNames } from '../../utils';
import { TtlDisplayElement } from '../ttl-element/ttl-element';
import { DomainDeliveryDisplay } from '../domain-delivery/domain-delivery-element';
import { NoTranslate } from '../no-translate/no-translate';
import { DomainNotificationEditor } from './domain-notification-settings-editor';
import { FormLayoutRow } from '../form-layout-row/form-layout-row';
import { NotificationFrequencyCapsDisplay } from '../notification-frequency-caps/notification-frequency-caps';
import { DeliveryThrottlingDisplay } from '../notification-delivery-throttling/notification-delivery-throttling-display';
export var GeneralDomainNotificationSettings = function GeneralDomainNotificationSettings(props) {
  var title = props.title,
      hideFooter = props.hideFooter,
      loading = props.loading,
      domain = props.domain,
      showInternalEditorAccessFields = props.showInternalEditorAccessFields,
      fetchCustomMacroFields = props.fetchCustomMacroFields,
      getAppContainer = props.getAppContainer,
      onSubmit = props.onSubmit,
      wellStyle = props.wellStyle;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      showDrawer = _React$useState2[0],
      setShowDrawer = _React$useState2[1];

  var wellClassName = wellStyle === 'halo' ? 'type-3' : '';

  function render() {
    return /*#__PURE__*/React.createElement(Well, {
      className: "nested ".concat(getClassNames('ddf-notif-actions-well'), " ").concat(wellClassName),
      title: title !== null && title !== void 0 ? title : 'General Settings',
      actions: /*#__PURE__*/React.createElement(Button, {
        size: "small",
        onClick: function onClick() {
          return setShowDrawer(true);
        },
        disabled: loading
      }, /*#__PURE__*/React.createElement(EditOutlined, null), /*#__PURE__*/React.createElement("span", null, "Edit")),
      hideFooter: hideFooter !== null && hideFooter !== void 0 ? hideFooter : true
    }, /*#__PURE__*/React.createElement(Skeleton, {
      loading: loading,
      active: true,
      title: false
    }, !loading && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TemplateWell, {
      domain: domain
    }), /*#__PURE__*/React.createElement(ActionsWell, {
      domain: domain,
      defaultOpenUrlLabelEnabled: false
    }), /*#__PURE__*/React.createElement(DeliveryWell, {
      domain: domain
    }), /*#__PURE__*/React.createElement(MediaWell, {
      domain: domain,
      showInternalEditorFields: showInternalEditorAccessFields
    }), /*#__PURE__*/React.createElement(UtmWell, {
      domain: domain
    }), /*#__PURE__*/React.createElement(CustomUtmParamsWell, {
      domain: domain
    }), /*#__PURE__*/React.createElement(DomainNotificationEditor, {
      key: showDrawer ? "open-".concat(domain.id) : "close-".concat(domain.id),
      domain: domain,
      defaultOpenUrlLabelEnabled: false,
      getAppContainer: getAppContainer,
      fetchCustomMacroFields: fetchCustomMacroFields,
      onClose: function onClose() {
        return setShowDrawer(false);
      },
      onSubmit: onSubmit,
      showInternalEditorAccess: true,
      visible: showDrawer
    }))));
  }

  return render();
};

var TemplateWell = function TemplateWell(_ref) {
  var _domain$landingUrlDom;

  var domain = _ref.domain;
  var allowList = (_domain$landingUrlDom = domain.landingUrlDomainWhitelist) !== null && _domain$landingUrlDom !== void 0 ? _domain$landingUrlDom : [];

  function render() {
    return /*#__PURE__*/React.createElement(Well, {
      title: "Landing URLs",
      mode: "ghost",
      hideFooter: true
    }, /*#__PURE__*/React.createElement(FormLayoutRow, {
      label: "Domain Allow List",
      value: allowList.join(', ') || '* (Any domain)',
      info: /*#__PURE__*/React.createElement("span", null, "Domains added to the allow list give control of which domains can be used when creating landing URLs."),
      infoIcon: /*#__PURE__*/React.createElement(WarningOutlined, null)
    }));
  }

  return render();
};

var ActionsWell = function ActionsWell(_ref2) {
  var domain = _ref2.domain,
      defaultOpenUrlLabelEnabled = _ref2.defaultOpenUrlLabelEnabled;
  var domainDefaultLabels = getDomainDefaultActionLabels(domain);
  var primaryAction = getNotificationActionOrDefault(domain, 0);
  var secondaryAction = getNotificationActionOrDefault(domain, 1);
  return /*#__PURE__*/React.createElement(Well, {
    title: "Action Button Defaults",
    mode: "ghost",
    hideFooter: true
  }, defaultOpenUrlLabelEnabled && /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: "Open URL Label",
    value: domainDefaultLabels.openUrl
  }), /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: "Buttons",
    value: /*#__PURE__*/React.createElement("div", {
      className: getClassNames('notif-action-builder-collection')
    }, /*#__PURE__*/React.createElement(NotificationActionBuilder, {
      domain: domain,
      mode: "static",
      enabled: true,
      title: "Button 1",
      config: primaryAction
    }), /*#__PURE__*/React.createElement(NotificationActionBuilder, {
      domain: domain,
      mode: "static",
      enabled: !!secondaryAction,
      title: "Button 2",
      noActionText: "No Default Button 2",
      config: secondaryAction
    }))
  }));
};

var DeliveryWell = function DeliveryWell(_ref3) {
  var _domain$displayMeta, _domain$displayMeta2;

  var domain = _ref3.domain;
  return /*#__PURE__*/React.createElement(Well, {
    title: "Delivery",
    mode: "ghost",
    hideFooter: true
  }, /*#__PURE__*/React.createElement(TtlDisplayElement, {
    entity: domain
  }), /*#__PURE__*/React.createElement(DomainDeliveryDisplay, {
    defaults: {
      type: (_domain$displayMeta = domain.displayMeta) === null || _domain$displayMeta === void 0 ? void 0 : _domain$displayMeta.default_delivery_type,
      window: (_domain$displayMeta2 = domain.displayMeta) === null || _domain$displayMeta2 === void 0 ? void 0 : _domain$displayMeta2.default_delivery_window
    },
    entity: domain
  }), /*#__PURE__*/React.createElement(NotificationFrequencyCapsDisplay, {
    domain: domain
  }), /*#__PURE__*/React.createElement(DeliveryThrottlingDisplay, {
    domain: domain
  }));
};

var MediaWell = function MediaWell(_ref4) {
  var domain = _ref4.domain,
      showInternalEditorFields = _ref4.showInternalEditorFields;
  return /*#__PURE__*/React.createElement(Well, {
    title: "Media",
    mode: "ghost",
    hideFooter: true
  }, showInternalEditorFields && /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: "Image Upload Quality",
    value: "".concat(domain.mediaQuality || 40, "%"),
    info: /*#__PURE__*/React.createElement("span", null, "Quality can be set anywhere between 30 & 100. Values lower than 40 may significantly impact images.")
  }), /*#__PURE__*/React.createElement("div", {
    className: "media-row"
  }, /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: "Notification Icon",
    value: !domain.defaultIconUrl ? 'No icon' : /*#__PURE__*/React.createElement("div", {
      className: getClassNames('media-display')
    }, /*#__PURE__*/React.createElement("div", {
      className: getClassNames('media-display-image'),
      style: {
        backgroundImage: "url(\"".concat(domain.defaultIconUrl, "\")")
      }
    }))
  }), /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: "Notification Badge",
    value: !domain.defaultBadgeUrl ? 'No badge' : /*#__PURE__*/React.createElement("div", {
      className: getClassNames('media-display')
    }, /*#__PURE__*/React.createElement("div", {
      className: getClassNames('media-display-image'),
      style: {
        backgroundImage: "url(\"".concat(domain.defaultBadgeUrl, "\")")
      }
    }))
  })));
};

var UtmWell = function UtmWell(_ref5) {
  var _utmParams$utm_source, _utmParams$utm_medium, _utmParams$utm_campai, _utmParams$utm_term, _utmParams$utm_conten;

  var domain = _ref5.domain;
  var utmParams = domain.utmParams || {};
  return /*#__PURE__*/React.createElement(Well, {
    title: "UTM Parameter",
    mode: "ghost",
    hideFooter: true
  }, /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: /*#__PURE__*/React.createElement(NoTranslate, null, "utm_source"),
    value: /*#__PURE__*/React.createElement(NoTranslate, null, (_utmParams$utm_source = utmParams === null || utmParams === void 0 ? void 0 : utmParams.utm_source) !== null && _utmParams$utm_source !== void 0 ? _utmParams$utm_source : utmParams === null || utmParams === void 0 ? void 0 : utmParams.utmSource)
  }), /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: /*#__PURE__*/React.createElement(NoTranslate, null, "utm_medium"),
    value: /*#__PURE__*/React.createElement(NoTranslate, null, (_utmParams$utm_medium = utmParams === null || utmParams === void 0 ? void 0 : utmParams.utm_medium) !== null && _utmParams$utm_medium !== void 0 ? _utmParams$utm_medium : utmParams === null || utmParams === void 0 ? void 0 : utmParams.utmMedium)
  }), /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: /*#__PURE__*/React.createElement(NoTranslate, null, "utm_campaign"),
    value: /*#__PURE__*/React.createElement(NoTranslate, null, (_utmParams$utm_campai = utmParams === null || utmParams === void 0 ? void 0 : utmParams.utm_campaign) !== null && _utmParams$utm_campai !== void 0 ? _utmParams$utm_campai : utmParams === null || utmParams === void 0 ? void 0 : utmParams.utmCampaign)
  }), /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: /*#__PURE__*/React.createElement(NoTranslate, null, "utm_term"),
    value: /*#__PURE__*/React.createElement(NoTranslate, null, (_utmParams$utm_term = utmParams === null || utmParams === void 0 ? void 0 : utmParams.utm_term) !== null && _utmParams$utm_term !== void 0 ? _utmParams$utm_term : utmParams === null || utmParams === void 0 ? void 0 : utmParams.utmTerm)
  }), /*#__PURE__*/React.createElement(FormLayoutRow, {
    label: /*#__PURE__*/React.createElement(NoTranslate, null, "utm_content"),
    value: /*#__PURE__*/React.createElement(NoTranslate, null, (_utmParams$utm_conten = utmParams === null || utmParams === void 0 ? void 0 : utmParams.utm_content) !== null && _utmParams$utm_conten !== void 0 ? _utmParams$utm_conten : utmParams === null || utmParams === void 0 ? void 0 : utmParams.utmContent)
  }));
};

var CustomUtmParamsWell = function CustomUtmParamsWell(_ref6) {
  var _domain$addedNotifica;

  var domain = _ref6.domain;
  var addedNotificationQueryParams = (_domain$addedNotifica = domain.addedNotificationQueryParams) !== null && _domain$addedNotifica !== void 0 ? _domain$addedNotifica : {};
  return /*#__PURE__*/React.createElement(Well, {
    title: "UTM Custom Parameters",
    className: "custom-utm-parameter-well",
    mode: "ghost",
    hideFooter: true
  }, Object.keys(addedNotificationQueryParams).length === 0 && /*#__PURE__*/React.createElement("div", null, "There are no custom UTM parameters"), Object.entries(addedNotificationQueryParams).map(function (_ref7, idx) {
    var _ref8 = _slicedToArray(_ref7, 2),
        name = _ref8[0],
        config = _ref8[1];

    return /*#__PURE__*/React.createElement(FormLayoutRow, {
      key: name,
      label: /*#__PURE__*/React.createElement(NoTranslate, null, name),
      value: /*#__PURE__*/React.createElement(NoTranslate, null, config["default"])
    });
  }));
};